//操作日志
export default [
    {
        alias: '',
        path: 'operationLog',
        name: 'operationLog',
        meta: {
            title: '操作日志',
            icon: 'operationLog'
        },
        hidden: false,
        component: () => import("@/views/system/operationLog/index.vue"),
        children: [{
            alias: '',
            path: 'logList',
            name: 'logList',
            meta: {
                title: '日志列表',
                icon: 'logList'
            },
            hidden: false,
            component: () => import("@/views/system/operationLog/logList.vue"),
        }]
    }

]